// IMPORTANTE: este import DEBE ir primero para parchear Node.prototype
// antes de que React o cualquier otra libreria se inicialice.
// Previene crashes por Google Translate (bug "removeChild on Node").
import './utils/googleTranslateFix';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import './utils/errorDiagnostic'; // expone window.__getErrors() para debug

const API_BASE = process.env.REACT_APP_API_APP || '';

// Helper para enviar errores globales al backend
const sendGlobalError = (payload) => {
  try {
    fetch(`${API_BASE}/client-errors`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...payload,
        url: window.location.href,
        userAgent: navigator.userAgent,
        viewport: `${window.innerWidth}x${window.innerHeight}`,
        online: navigator.onLine,
        language: navigator.language,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch (_) {}
};

// Capturar errores no manejados de promesas (async/await sin catch)
window.addEventListener('unhandledrejection', (event) => {
  const errorId = `ERR-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
  console.error('🚨 Unhandled Promise Rejection:', errorId, event.reason);

  const payload = {
    errorId,
    errorName: event.reason?.name,
    message: String(event.reason?.message || event.reason),
    stack: event.reason?.stack,
    errorType: 'unhandledrejection',
  };

  try {
    sessionStorage.setItem('lastUnhandledRejection', JSON.stringify({
      ...payload,
      timestamp: new Date().toISOString(),
    }));
  } catch (_) {}

  sendGlobalError(payload);
});

// Capturar errores globales (fuera de React)
window.addEventListener('error', (event) => {
  const errorId = `ERR-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`;
  console.error('🚨 Global Error:', errorId, event.error || event.message);

  const payload = {
    errorId,
    errorName: event.error?.name,
    message: event.message,
    stack: event.error?.stack,
    source: event.filename,
    line: event.lineno,
    col: event.colno,
    errorType: 'global',
  };

  try {
    sessionStorage.setItem('lastGlobalError', JSON.stringify({
      ...payload,
      timestamp: new Date().toISOString(),
    }));
  } catch (_) {}

  sendGlobalError(payload);
});

const root = ReactDOM.createRoot(document.getElementById('root'));
// 🧪 SOLO LOCAL — StrictMode duplica el render en dev y dispara un loop de
// setState en el ResizeObserver de antd Typography (React 19) que crashea el
// checkout. Lo desactivamos únicamente en el entorno local de pruebas.
const StrictWrapper = process.env.REACT_APP_ENV === 'local' ? React.Fragment : React.StrictMode;
root.render(
  <StrictWrapper>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictWrapper>
);
